import styled from "styled-components";
import theme from "../../../../Styles/theme";


export const InputContainer = styled.div`

   
    margin-top:5vh;
    width:calc(20% + 200px);
`;

export const InputButton = styled.div`

    display: flex;
    align-items: center;
    justify-content:center;
    width:100%;

    margin-top:2vh;

`;


export const HelperSpan = styled.div`
    display: flex;
    align-items: center;
    margin-top:10vh;

`;


export const HandleGroupInput = styled.div`

display: flex;
align-items: center;
justify-content:space-between;

`;


export const HandleInputSenha = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2vh;

`;
export const InputSenha = styled.input`
  width:calc(20% + 200px);
  border: none;
  background-color: ${theme.colors.light};
  border-radius: 0.25rem;
 color: ${theme.colors.dark};
  padding: 1vh 2vw;
  font-size: max(8px, 1vw);
  padding: 2vh 1vw;
`;